<i18n src="@/locales/models/liquidation.yml" lang="yaml"></i18n>
<template>
  <div class="mt-6">
    <badge-default class="my-2" :label="`${total_rows}`" />
    <ag-grid-vue
      style="width: 100%; height: 650px"
      class="ag-theme-alpine w-full h-full"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="data"
    >
    </ag-grid-vue>
    <table-paginator
      v-if="data_loaded"
      v-model="current_page"
      :total_rows="total_rows"
      :rows_per_page="rows_per_page"
    />
  </div>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/production/query_by_provider/show_process.js"
import { AgGridVue } from "ag-grid-vue3";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";

export default {
  name: "AEProductionQueryByProviderWeeklyTable",
  components: {
    AgGridVue,
    TablePaginator
  },
  props: {
    agro_exporter_id: { required: true },
    agro_exporter_process_id: { required: true },
  },
  data() {
    return {
      defaultColDef: {
        sortable: true,
        filter: true,
        floatingFilter: true
      },
      current_page: 1,
      rows_per_page: 13,
      total_rows: 0,
      data: [],
      data_loaded: false
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData: async function () {
      await this.fetchTotalWeeklySummary();
      await this.fetchWeeklySummary();
      this.data_loaded = true
    },
    fetchTotalWeeklySummary: async function () {
      let response = await Requester.fetchTotalWeeklySummary(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.total_rows = response.data;
    },
    fetchWeeklySummary: async function () {
      let response = await Requester.fetchWeeklySummary(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.current_page,
        this.rows_per_page
      )
      this.data = response.data;
    },
    // sizeToFit() {
    //   this.gridApi.sizeColumnsToFit({
    //     defaultMinWidth: 150
    //   });
    // },
    // onGridReady(params) {
    //   this.gridApi = params.api;
    //   this.gridColumnApi = params.columnApi;
    //   this.sizeToFit();
    // }
  },
  computed: {
    columnDefs: function () {
      return [
        {
          headerName: "Mes",
          field: "month",
          filter: true,
          resizable: false,
          pinned: 'left',
          maxWidth: 150
        },
        {
          headerName: "Semana",
          field: "week",
          filter: true,
          resizable: false,
          pinned: 'left',
          maxWidth: 150
        },
        {
          headerName: "Productor",
          field: "producer",
          filter: true,
          flex: 1.5,
        },
        {
          headerName: "Kilos Cosechados",
          field: "total_weight",
          filter: true,
          flex: 1,
          cellRendererSelector: params => {
            const Cell = {
              template: `<p>{{ numberWithPrecision(${params.value}, 2) }}</p>`
            };
            return { component: Cell }
          }
        },
        {
          headerName: "Kilos Exportados",
          field: "ok_weight",
          filter: true,
          flex: 1,
          cellRendererSelector: params => {
            const Cell = {
              template: `<p>{{ numberWithPrecision(${params.value}, 2) }}</p>`
            };
            return { component: Cell }
          }
        },
        {
          headerName: "Kilos descartados",
          field: "discarded_weight",
          filter: true,
          flex: 1,
          cellRendererSelector: params => {
            const Cell = {
              template: `<p>{{ numberWithPrecision(${params.value}, 2) }}</p>`
            };
            return { component: Cell }
          }
        },
      ]
    },
  //   weeks: function () {
  //     let weeks = [];
  //     for (const [month, data] of Object.entries(this.data)) {
  //       data.forEach(week => {
  //         weeks.push({
  //           month: month,
  //           ...week,
  //           ...week.average_fob_by_crop_size
  //         })
  //       })
  //     }
  //     return weeks;
  //   }
  },
  watch: {
    current_page: function () {
      this.fetchWeeklySummary();
    }
  }
};
</script>
